import { useCenter, useCenterCourses, type CenterCourse } from "../../center";

/**
 * The courses a mentoring can be booked on: a training centre's, for its
 * mentors. Empty for anybody else, who books sessions with no course at all.
 */
export function useMentoringCourses(): CenterCourse[] {
    const { center } = useCenter();
    const isTraining = center?.type === "training";
    const { courses } = useCenterCourses(center?.id, isTraining);
    return isTraining ? courses : [];
}
